import { FC, useState } from 'react';
import ServiceScheduleException from 'interfaces/serviceScheduleException';
import CustomDayRow from 'components/CustomDayRow/CustomDayRow';
import ServiceRowThreeDotsOption from './ServiceRowThreeDotsOption/ServiceRowThreeDotsOption';
import { IService } from 'interfaces/services';

interface ServiceCustomDayItemProps {
  day: ServiceScheduleException;
  service: IService;
}

const ServiceCustomDayItem: FC<ServiceCustomDayItemProps> = ({
  day,
  service,
}) => {
  const [isShown, setIsShown] = useState(false);

  const displayDate = () => {
    const isClosed = day.shifts.some(
      (shift) => !shift.startTime && !shift.endTime
    );
    return isClosed ? 'Unavailable' : 'Custom hours';
  };

  return (
    <CustomDayRow
      setIsShown={setIsShown}
      getDisplayDate={displayDate}
      day={day}
      onClick={() => {}}
    >
      <ServiceRowThreeDotsOption
        day={day}
        service={service}
        isShown={isShown}
      />
    </CustomDayRow>
  );
};

export default ServiceCustomDayItem;
